// 弹框类型
export const DIALOG_ADD = 0;
export const DIALOG_EDIT = 1;
export const DIALOG = {
    [DIALOG_ADD]: '新建',
    [DIALOG_EDIT]: '编辑',
};

// 禁用状态
export const ENABLE_TRUE = 0;
export const ENABLE_FALSE = 1;
export const ENABLE = {
    [ENABLE_TRUE]: '禁用',
    [ENABLE_FALSE]: '启用',
};

// 角色
export const ROLE_ADMIN = 1;
export const ROLE_OPERATOR = 2;
export const ROLE = [
    { value: ROLE_ADMIN, label: '管理员' },
    { value: ROLE_OPERATOR, label: '操作员' },
];

// 设备 - tab 切换类型
export const TABS_UNBIND = 0;
export const TABS_BIND = 1;
export const TABS = [
    { value: TABS_UNBIND, label: '未分配设备' },
    { value: TABS_BIND, label: '已分配设备' },
];
export const TABS_MAP = {
    [TABS_UNBIND]: '未分配设备',
    [TABS_BIND]: '已分配设备',
};

// 设备 - 联通状态
export const STATUS_NO = 0;
export const STATUS_OK = 1;
export const STATUS_ARRAY = [
    { value: STATUS_NO, label: '未联通' },
    { value: STATUS_OK, label: '已联通' },
];
export const STATUS_MAP = {
    [STATUS_NO]: '未联通',
    [STATUS_OK]: '已联通',
};

// 设备 - 授权类型
export const AUTH_PROBATION = 1;
export const AUTH_PERMANENT = 2;
export const AUTH_ARRAY = [
    { value: AUTH_PROBATION, label: '试用' },
    { value: AUTH_PERMANENT, label: '永久' },
];
export const AUTH_MAP = {
    [AUTH_PROBATION]: '试用',
    [AUTH_PERMANENT]: '永久',
};

// 设备管理 --> 分配、授权弹框
export const DEVICE_BIND = 1;
export const DEVICE_AUTH = 2;
export const DEVICE_DIALOG = {
    [DEVICE_BIND]: '分配商户',
    [DEVICE_AUTH]: '修改授权',
};

// 素材管理 --> 文件移动、复制弹框
export const FILE_MOVE = 1;
export const FILE_COPY = 2;
export const FILE_DIALOG = {
    [FILE_MOVE]: '移动素材',
    [FILE_COPY]: '复制素材',
};
